import { useEffect } from 'react';
import '@components/Admin/Modal.css';

function Modal({ isOpen, onClose, title, children, size = 'medium' }) {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [isOpen, onClose]);
    
    if (!isOpen) return null;
    
    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div 
                className={`admin-modal admin-modal-${size}`} 
                onClick={(e) => e.stopPropagation()}
            >
                <button className="admin-modal-close" onClick={onClose}>
                    <i className="fas fa-times"></i>
                </button>
                
                {title && (
                    <div className="admin-modal-header">
                        <h2>{title}</h2>
                    </div>
                )}
                
                <div className="admin-modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;

